module.exports = __webpack_public_path__ + "static/media/support.1ab4454c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support.png
// module id = 205
// module chunks = 0